export const STORAGE_KEYS = {
  VERSION: 'VERSION',
};
